module.exports = __webpack_public_path__ + "img/srl.6cf669a0.svg";